// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:360px){.logo_wrap{font-size:21px}.logo_wrap .logo_text_wrap .title{font-size:30px}}", ""]);
// Exports
module.exports = exports;
